import { NgModule } from '@angular/core';
import * as coreServices from './index';
@NgModule({
  imports: [],
  providers: [...coreServices.services]
})
export class CoreModule {}
